/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';


    function promptCustomerSignatureQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


    export function promptCustomerSignatureInput (
        poiId:
            string,
            saleId:
            string,
            serviceId:
            string
    ): IDataServiceRequest {
    const query = promptCustomerSignatureQuery();
    return query.createDataServiceRequestForOperation(
        'PromptCustomerSignature',
        true,
        DataServiceEntities.CustomerSignatureExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICustomerSignature' },
        {
            poiId: poiId,
            saleId: saleId,
            serviceId: serviceId
        }
    );
}

export function promptCustomerSignatureAsync(
    context: IContext,
    poiId: string,
    saleId: string,
    serviceId: string
): AsyncResult<DataServiceEntities.ICustomerSignature> {
    const request = promptCustomerSignatureInput(poiId, saleId, serviceId);
    return callActionOrExecute<DataServiceEntities.ICustomerSignature>(request, context.callerContext);
}

function getDemoProductsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


    export function getDemoProductsInput (
    queryResultSettings: IQueryResultSettings,
    locationId: string,
    languageId: string
): IDataServiceRequest {
    const query = getDemoProductsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetDemoProducts',
        true,
        DataServiceEntities.SignItemExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISignItem' },
        {
            locationId: locationId,
            languageId: languageId
        }
    );
}

export function getDemoProductsAsync(
    context: IContext,
    locationId: string,
    languageId: string
): AsyncResult<DataServiceEntities.ISignItem[]> {
    const request = getDemoProductsInput(context.queryResultSettings || {}, locationId, languageId);
    return callActionOrExecute<DataServiceEntities.ISignItem[]>(request, context.callerContext);
}

function getDemoStoresQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


    export function getDemoStoresInput (
        queryResultSettings: IQueryResultSettings
    ): IDataServiceRequest {
    const query = getDemoStoresQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetDemoStores',
        true,
        DataServiceEntities.DemoStoreExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IDemoStore' },
        {}
    );
}

export function getDemoStoresAsync(context: IContext): AsyncResult<DataServiceEntities.IDemoStore[]> {
    const request = getDemoStoresInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IDemoStore[]>(request, context.callerContext);
}

function getGroupedAttributesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


    export function getGroupedAttributesInput (
    queryResultSettings: IQueryResultSettings,
    channelId: number,
    catalogId: number,
    productId: number
): IDataServiceRequest {
    const query = getGroupedAttributesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetGroupedAttributes',
        true,
        DataServiceEntities.ProductAttributeGroupExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProductAttributeGroup' },
        {
            channelId: channelId,
            catalogId: catalogId,
            productId: productId
        }
    );
}

export function getGroupedAttributesAsync(
    context: IContext,
    channelId: number,
    catalogId: number,
    productId: number
): AsyncResult<DataServiceEntities.IProductAttributeGroup[]> {
    const request = getGroupedAttributesInput(context.queryResultSettings || {}, channelId, catalogId, productId);
    return callActionOrExecute<DataServiceEntities.IProductAttributeGroup[]>(request, context.callerContext);
}

function exportProductPricesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


    export function exportProductPricesInput (
        queryResultSettings: IQueryResultSettings, skip:
            number,
            top:
            number
    ): IDataServiceRequest {
    const query = exportProductPricesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'ExportProductPrices',
        true,
        DataServiceEntities.ProductPriceInfoExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProductPriceInfo' },
        {
            skip: skip,
            top: top
        }
    );
}

export function exportProductPricesAsync(
    context: IContext,
    skip: number,
    top: number
): AsyncResult<DataServiceEntities.IProductPriceInfo[]> {
    const request = exportProductPricesInput(context.queryResultSettings || {}, skip, top);
    return callActionOrExecute<DataServiceEntities.IProductPriceInfo[]>(request, context.callerContext);
}

function exportProductFeedQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


    export function exportProductFeedInput (
    queryResultSettings: IQueryResultSettings,
    skip: number,
    top: number,
    sku: string
): IDataServiceRequest {
    const query = exportProductFeedQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'ExportProductFeed',
        true,
        DataServiceEntities.ProductFeedInfoExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProductFeedInfo' },
        {
            skip: skip,
            top: top,
            sku: sku
        }
    );
}

export function exportProductFeedAsync(
    context: IContext,
    skip: number,
    top: number,
    sku: string
): AsyncResult<DataServiceEntities.IProductFeedInfo[]> {
    const request = exportProductFeedInput(context.queryResultSettings || {}, skip, top, sku);
    return callActionOrExecute<DataServiceEntities.IProductFeedInfo[]>(request, context.callerContext);
}

function refreshProductFeedQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


    export function refreshProductFeedInput (

    ): IDataServiceRequest {
    const query = refreshProductFeedQuery();
    return query.createDataServiceRequestForOperation(
        'RefreshProductFeed',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {}
    );
}

export function refreshProductFeedAsync(context: IContext): AsyncResult<number> {
    const request = refreshProductFeedInput();
    return callActionOrExecute<number>(request, context.callerContext);
}

function getProductInfoQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


    export function getProductInfoInput (
        sku:
            string
    ): IDataServiceRequest {
    const query = getProductInfoQuery();
    return query.createDataServiceRequestForOperation(
        'GetProductInfo',
        true,
        DataServiceEntities.ProductInfoExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProductInfo' },
        {
            sku: sku
        }
    );
}

export function getProductInfoAsync(context: IContext, sku: string): AsyncResult<DataServiceEntities.IProductInfo> {
    const request = getProductInfoInput(sku);
    return callActionOrExecute<DataServiceEntities.IProductInfo>(request, context.callerContext);
}

function getWhatisinBoxQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


    export function getWhatisinBoxInput (
        sku:
            string
    ): IDataServiceRequest {
    const query = getWhatisinBoxQuery();
    return query.createDataServiceRequestForOperation(
        'GetWhatisinBox',
        true,
        DataServiceEntities.WhatisinBoxExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IWhatisinBox' },
        {
            sku: sku
        }
    );
}

export function getWhatisinBoxAsync(context: IContext, sku: string): AsyncResult<DataServiceEntities.IWhatisinBox> {
    const request = getWhatisinBoxInput(sku);
    return callActionOrExecute<DataServiceEntities.IWhatisinBox>(request, context.callerContext);
}

function getProductPromotionsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


    export function getProductPromotionsInput (
    queryResultSettings: IQueryResultSettings,
    recordId: number,
    distinctProductVariantId: number
): IDataServiceRequest {
    const query = getProductPromotionsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetProductPromotions',
        true,
        DataServiceEntities.ProductPromotionExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProductPromotion' },
        {
            recordId: recordId,
            distinctProductVariantId: distinctProductVariantId
        }
    );
}

export function getProductPromotionsAsync(
    context: IContext,
    recordId: number,
    distinctProductVariantId: number
): AsyncResult<DataServiceEntities.IProductPromotion[]> {
    const request = getProductPromotionsInput(context.queryResultSettings || {}, recordId, distinctProductVariantId);
    return callActionOrExecute<DataServiceEntities.IProductPromotion[]>(request, context.callerContext);
}

function getPromotionInfoQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


    export function getPromotionInfoInput (
        code:
            string
    ): IDataServiceRequest {
    const query = getPromotionInfoQuery();
    return query.createDataServiceRequestForOperation(
        'GetPromotionInfo',
        true,
        DataServiceEntities.DiscountInfoExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IDiscountInfo' },
        {
            code: code
        }
    );
}

export function getPromotionInfoAsync(context: IContext, code: string): AsyncResult<DataServiceEntities.IDiscountInfo> {
    const request = getPromotionInfoInput(code);
    return callActionOrExecute<DataServiceEntities.IDiscountInfo>(request, context.callerContext);
}

// @ts-ignore
function networkInventoryQuery(productId?: number): DataServiceQuery {
    const key = productId ? { ProductId: productId } : null;
    return new DataServiceQuery(
        'NetworkInventory',
        'NetworkInventoryAvailableQuantity',
        DataServiceEntities.NetworkInventoryAvailableQuantityExtensionClass,
        key);
}

export function createCheckInventoryInput(
    queryResultSettings: IQueryResultSettings,
    itemIds: number[],
    shouldCheckAttribute: boolean
): IDataServiceRequest {
    const query = networkInventoryQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'CheckInventory',
        true,
        DataServiceEntities.NetworkInventoryAvailableQuantityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.INetworkInventoryAvailableQuantity' },
        { itemIds: itemIds, shouldCheckAttribute: shouldCheckAttribute }
    );
}

export function checkInventoryAsync(
    context: IContext,
    itemIds: number[],
    shouldCheckAttribute: boolean
): AsyncResult<DataServiceEntities.INetworkInventoryAvailableQuantity[]> {
    const request = createCheckInventoryInput(context.queryResultSettings || {}, itemIds, shouldCheckAttribute);
    return callActionOrExecute<DataServiceEntities.INetworkInventoryAvailableQuantity[]>(request, context.callerContext);
}

export function createGetInventoryLabelInput(
    queryResultSettings: IQueryResultSettings,
    availabilities: DataServiceEntities.INetworkInventoryLabelInput[],
    channelId: number
): IDataServiceRequest {
    const query = networkInventoryQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetInventoryLabel',
        true,
        DataServiceEntities.NetworkInventoryLabelExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.INetworkInventoryLabel' },
        { availabilities: availabilities, channelId: channelId }
    );
}


    export function getInventoryLabelAsync(context: IContext, availabilities: DataServiceEntities.INetworkInventoryLabelInput[], channelId: number): AsyncResult<DataServiceEntities.INetworkInventoryLabel[]> {
    const request = createGetInventoryLabelInput(context.queryResultSettings || {}, availabilities, channelId);
    return callActionOrExecute<DataServiceEntities.INetworkInventoryLabel[]>(request, context.callerContext);
}

export function createTestInput(itemIds: number[]): IDataServiceRequest {
    const query = networkInventoryQuery();
    return query.createDataServiceRequestForOperation(
        'Test',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { itemIds: itemIds }
    );
}


    export function testAsync(context: IContext, itemIds: number[]): AsyncResult<string> {
    const request = createTestInput(itemIds);
    return callActionOrExecute<string>(request, context.callerContext);
}

// @ts-ignore
function flexitiPaymentQuery(transactionId?: string): DataServiceQuery {
    const key = transactionId ? { transactionId: transactionId } : null;
    return new DataServiceQuery('FlexitiPayment', 'FlexitiTransactions', DataServiceEntities.FlexitiTransactionsExtensionClass, key);
}


    export function createGetFlexitiPaymentTransactionsInput(queryResultSettings: IQueryResultSettings, flexitiPaymentCustomer: DataServiceEntities.IFlexitiPaymentCustomer): IDataServiceRequest {
    const query = flexitiPaymentQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetFlexitiPaymentTransactions',
        true,
        DataServiceEntities.FlexitiTransactionsExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IFlexitiTransactions' },
        { flexitiPaymentCustomer: flexitiPaymentCustomer }
    );
}


    export function getFlexitiPaymentTransactionsAsync(context: IContext, flexitiPaymentCustomer: DataServiceEntities.IFlexitiPaymentCustomer): AsyncResult<DataServiceEntities.IFlexitiTransactions[]> {
    const request = createGetFlexitiPaymentTransactionsInput(context.queryResultSettings || {}, flexitiPaymentCustomer);
    return callActionOrExecute<DataServiceEntities.IFlexitiTransactions[]>(request, context.callerContext);
}

// @ts-ignore
function mfrCodeQuery(product?: number): DataServiceQuery {
    const key = product ? { Product: product } : null;
    return new DataServiceQuery('MfrCode', 'MfrCodeClass', DataServiceEntities.MfrCodeClassExtensionClass, key);
}


    export function createGetMfrCodeInput(productId: number): IDataServiceRequest {
    const query = mfrCodeQuery();
    return query.createDataServiceRequestForOperation(
        'GetMfrCode',
        false,
        DataServiceEntities.MfrCodeClassExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IMfrCodeClass' },
        { productId: productId }
    );
}

export function getMfrCodeAsync(context: IContext, productId: number): AsyncResult<DataServiceEntities.IMfrCodeClass> {
    const request = createGetMfrCodeInput(productId);
    return callActionOrExecute<DataServiceEntities.IMfrCodeClass>(request, context.callerContext);
}
